import { minifyHtml } from '../htmlHelper'

import { unwrapFromBElement } from './unwrapFromBElement'

export const prepareTablesFromOtherEditors = (parsedDoc: Document) => {
  const tableElements = parsedDoc.querySelectorAll('table')
  tableElements.forEach((table) => {
    // When copying, we use minification only for tables, because in the markup from Word they have extra spaces
    const tableHTML = table.innerHTML
    const strippedHTML = minifyHtml(tableHTML)
    table.innerHTML = strippedHTML

    // Tables from google doc are wrapped in an extra b tag, so we remove it for correct parsing
    const parentElement = table.parentElement?.parentElement
    if (parentElement?.tagName.toLowerCase() === 'b') {
      unwrapFromBElement(parentElement)
    }
    const colgroups = table.querySelectorAll('colgroup')
    colgroups.forEach((colgroup) => {
      colgroup.remove()
    })
    const styles = table.getAttribute('style')
    const newStyles = styles ? styles.replace(/(?:^|;)\s*width\s*:\s*[^;]+/g, '') : ''
    table.setAttribute('style', newStyles)
  })
}
